import React from "react";
import Chart from "react-apexcharts";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
const processMonthlyData = (saleData1) => {
    if (!saleData1 || !Array.isArray(saleData1)) {
    return { processedData: [], totalSalesCountData: [] };
  }

  const processedData = [];
  const totalSalesCountData = [];
  const saleData = saleData1.filter(
    (item) => item.totalAmount >= 0 && item.noOfSales >= 0
  );
  saleData?.forEach((item) => {

    const date = DateConverter.ISOToDisplayFormat(
              DateConverter.convertToTimeZone(item.saledate),
              "dd LLL yyyy"
            ).date
    const dayString = date.split(' ')[0]; 
    const day = parseInt(dayString, 10);
      
    processedData.push({
      x: day,
      y: CurrencyConverter.toCurrency(item.totalAmount || 0, "INR"),
    });
 
  });


  processedData.sort((a, b) => a.x - b.x);
  totalSalesCountData.sort((a, b) => a.x - b.x);

  return { processedData, totalSalesCountData };
};

function MonthlySaleAnalytics({ AnalyticsData }) {
  const { lastMonth, thisMonth } = AnalyticsData;

  const { processedData: thisMonthAmount, totalSalesCountData: thisMonthSales } = processMonthlyData(thisMonth?.saleData);
  const { processedData: lastMonthAmount, totalSalesCountData: lastMonthSales } = processMonthlyData(lastMonth?.saleData);

  const axisLabelStyle = {
    fontSize: "12px",
    fontWeight: "500",
    fontFamily: "Inter, sans-serif !important ",
  };

  const axisTitleStyle = {
    fontSize: "14px",
    fontWeight: "500",
    colors: ["#636578"],
    fontFamily: "Inter, sans-serif !important",
  };

  const maxDay = Math.max(
    ...[...thisMonthAmount, ...lastMonthAmount].map(d => d.x),
    ...[...thisMonthSales, ...lastMonthSales].map(d => d.x)
  );
  
  const allAmounts = [
    ...thisMonthAmount.map((item) => item.y),
    ...lastMonthAmount.map((item) => item.y)
  ];

const minAmount = allAmounts.length > 0 ? Math.min(...allAmounts) : 0;
  const maxAmount = allAmounts.length > 0 ? Math.max(...allAmounts) : 0;

  const chartOptions = {
    chart: {
      foreColor: "#9ba7b2",
      height: 360,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      dropShadow: {
        enabled: true,
        top: 3,
        left: 14,
        blur: 4,
        opacity: 0.1,
      },
    },
    stroke: {
      width: 5,
      curve: "smooth",
    },
    legend: {
      show: false,
    },
   colors: ["#303f9f", "#9da3cbff"],
    xaxis: {
      type: "numeric",
      tickAmount: Math.min(maxDay || 31, 31), 
      min: 1,
      max: 31,
      title: {
        text: "Day of the Month",
        style: axisTitleStyle,
      },
      labels: {
        formatter: (value) => Math.floor(value),
        style: axisLabelStyle,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: [
      {
        seriesName: ["Sale Amount"], 
        // max: Math.round(maxAmount),
        // min: Math.round(minAmount),
  
          tickAmount: 5,
        title: {
          text: "Total Amount",
          style: axisTitleStyle,
        },
        labels: {
          formatter: (value) => Math.round(value || 0),
          style: { ...axisLabelStyle, colors: ["#888888"] },
        },
      },      
    ],
    tooltip: {
      enabled: true,
      theme: "light",
      x: {
        formatter: (value) => `Day: ${Math.floor(value)}`,
      },
      y: [
        {
          formatter: (value) => `₹${(value || 0).toLocaleString('en-IN')}`,
          title: {
            formatter: () => "Sale Amount:",
          },
        },
        {
          formatter: (value) => `₹${(value || 0)}`,
          title: {
            formatter: () => "Sale Amount",
          },
        },
      ],
      marker: {
        show: true,
      },
    },
    markers: {
      size: 4,
      colors: ["#303f9f", "#9da3cbff"],
      strokeColors: "#fff",
      strokeWidth: 2,
      fillOpacity: 1,
      shape: "circle",
      radius: 2,
      hover: {
        size: 7,
      },
    },
    grid: {
      row: {
        colors: ["transparent"],
        opacity: 0.5,
      },
    },
  };

  const chartSeries = [
    {
      name: "Last Month Sale Amount",
      type: "line",
      data: lastMonthAmount,
      color: "#9da3cbff",
    }, 
    {
      name: "This Month Sale Amount",
      type: "line",
      data: thisMonthAmount,
      color: "#303f9f",
    },
      
  ];

  const legendItems = [
    { label: "Last Month ", color: "#9da3cbff" }, 
    { label: "This Month ", color: "#303f9f" },    
  ];

  // const hasData = thisMonthAmount.length > 0 || lastMonthAmount.length > 0;

  return (
    <div className="card-body p-0">
      <div className="row row-bordered g-0 h-100">
        <div className="col-md-12 col-12 p-3">
          {/* {hasData ? ( */}
            <>
              <div className="d-flex justify-content-end gap-2 flex-wrap mb-3">
                {legendItems.map((item) => (
                  <div
                    className="d-flex justify-content-center align-items-center font-13 gap-1 me-2"
                    key={item.label}
                  >
                    <span
                      style={{
                        width: 12,
                        height: 12,
                        backgroundColor: item.color,
                        borderRadius: "12px",
                      }}
                    />
                    {item.label}
                  </div>
                ))}
              </div>
              <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
                height={300}
              />
            </>
          {/* // ) : (
          //   <p className="p-2 text-center">No sales data available for this month or last month.</p>
          // )} */}
        </div>
      </div>
    </div>
  );
}

export default MonthlySaleAnalytics;